import React from "react";
import PropTypes from "prop-types";
import CitySection from "../CitySection/CitySection";
import "./CitiesGrid.scss";

export default function CitiesGrid({ cities }) {
	return (
		<section className="slp-cities-grid">
			<div className="slp-cities-grid__inner">
				{cities.map((city) => (
					<div
						key={city.name}
						className="slp-cities-grid__item"
					>
						<CitySection city={city} />
					</div>
				))}
			</div>
		</section>
	);
}

CitiesGrid.propTypes = {
	cities: PropTypes.arrayOf(PropTypes.object).isRequired
};
